import { asOrgId, type OrgId } from '@reflex/ui/client/api/org-id';
import { useOrgKey } from '@/hooks/auth/useOrgKey';

/**
 * The active organization as a branded {@link OrgId}, or `null` during the
 * pre-auth bootstrap window (when {@link useOrgKey} resolves to the `'global'`
 * sentinel).
 *
 * This is the web-app counterpart to `@reflex/ui/client/api/org-id`'s
 * `useActiveOrgId`, which resolves org from the *plugin* client context. The
 * web app's source of truth is its own auth (`useOrgKey` → `useAuth`), so the
 * org-safe API facades (`@reflex/ui/client/api/*`) must be fed the org branded
 * from here. Org-scoped pages render under `/orgs/:slug`, so this is non-null
 * there; callers must still handle `null` before invoking an org-scoped hook,
 * which is exactly the compile-time guard the branded `OrgId` enforces.
 */
export function useActiveOrgId(): OrgId | null {
  const orgKey = useOrgKey();
  return orgKey && orgKey !== 'global' ? asOrgId(orgKey) : null;
}
